'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.composeCopy = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*global __DEV__*/


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.template');

var _lodash4 = _interopRequireDefault(_lodash3);

var _getDisplayName = require('./getDisplayName');

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *  Does some checks before setting on the composed copy object
 */
var setComposedCopyKey = function setComposedCopyKey(composedCopy, key, value) {
    if ("production" !== process.env.NODE_ENV) {
        (0, _invariant2.default)(typeof composedCopy[key] === 'undefined', 'Key "%s" is already defined with copy: "%s"', key, composedCopy[key]);

        (0, _invariant2.default)(typeof value !== 'undefined', 'Copy value for key "%s" is "undefined". Most likely missing from ' + 'the context (global) copy', key);
    }
    composedCopy[key] = value;
};

/**
 *  Creates the composed copy using the copy from context and the passed-in
 *  array of configs
 */
var composeCopy = exports.composeCopy = function composeCopy() {
    var contextCopy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var configsArr = arguments[1];
    return configsArr.reduce(function (composedCopy, options) {
        var keys = options.keys;
        var copy = options.copy,
            path = options.path;


        if ("production" !== process.env.NODE_ENV) {
            (0, _invariant2.default)(keys && !copy || !keys && copy, // XOR
            'Found "keys" and "copy" in copy object. Only one should exist ' + 'in a single copy object');
        }

        // Passed-in keys checks the context for copy
        if (keys) {
            keys = Array.isArray(keys) ? keys : [keys];
            keys.forEach(function (key) {
                if ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object') {
                    // Renaming key using format { 'originalKey': 'newKey' }
                    Object.keys(key).forEach(function (originalKey) {
                        var newKey = key[originalKey];
                        setComposedCopyKey(composedCopy, newKey, (0, _lodash2.default)(contextCopy, path ? path + '.' + originalKey : originalKey));
                    });
                } else {
                    setComposedCopyKey(composedCopy, key, (0, _lodash2.default)(contextCopy, path ? path + '.' + key : key));
                }
            });
        }

        // Passed-in copy is it's own set of copy, transfer to composed copy
        if (copy) {
            Object.keys(copy).forEach(function (key) {
                if ("production" !== process.env.NODE_ENV) {
                    var copyKeyType = _typeof(copy[key]);
                    (0, _invariant2.default)(copyKeyType === 'string', 'Passed option "copy" should be object of strings only, ' + 'instead found type "%s" for key "%s"', copyKeyType, key);
                }
                setComposedCopyKey(composedCopy, key, copy[key]);
            });
        }

        return composedCopy;
    }, {});
};

exports.default = function () {
    for (var _len = arguments.length, configsArr = Array(_len), _key = 0; _key < _len; _key++) {
        configsArr[_key] = arguments[_key];
    }

    // Cache so all uses of this instance of the HOC don't have to repeat
    // the processing
    var copyCache = void 0;

    return function (BaseComponent) {
        var baseComponentName = (0, _getDisplayName2.default)(BaseComponent);
        var wrappedDisplayName = 'copier(' + baseComponentName + ')';

        if ("production" !== process.env.NODE_ENV) {

            // If BaseComponent has propTypes.copy defined, check that it's set as
            // PropTypes.func (and PropTypes.func.isRequired)
            (0, _invariant2.default)(!BaseComponent.propTypes || BaseComponent.propTypes.copy === _propTypes2.default.func || BaseComponent.propTypes.copy === _propTypes2.default.func.isRequired || BaseComponent.propTypes.copy === _react2.default.PropTypes.func || BaseComponent.propTypes.copy === _react2.default.PropTypes.func.isRequired, '%s.propType.copy is not set as React.PropTypes.func[.isRequired]', baseComponentName);
        }

        var Copied = function (_Component) {
            _inherits(Copied, _Component);

            function Copied(props) {
                _classCallCheck(this, Copied);

                var _this = _possibleConstructorReturn(this, (Copied.__proto__ || Object.getPrototypeOf(Copied)).call(this, props));

                _this.getCopy = _this.getCopy.bind(_this);
                return _this;
            }

            _createClass(Copied, [{
                key: 'componentWillMount',
                value: function componentWillMount() {
                    if (!copyCache) {
                        copyCache = composeCopy((0, _lodash2.default)(this.context, 'copier.copy'), configsArr);
                    }
                    this._copy = copyCache;
                }
            }, {
                key: '_getCopyByKey',
                value: function _getCopyByKey(key, params) {
                    if ("production" !== process.env.NODE_ENV) {
                        (0, _invariant2.default)(Object.keys(this._copy).indexOf(key) >= 0, 'No copy defined for key "%s" in component "%s"', key, wrappedDisplayName);
                    }
                    if (params) {
                        return (0, _lodash4.default)((0, _lodash2.default)(this._copy, key))(params);
                    }
                    return (0, _lodash2.default)(this._copy, key);
                }
            }, {
                key: 'getCopy',
                value: function getCopy(key, params) {
                    var _this2 = this;

                    if (Array.isArray(key)) {
                        return key.reduce(function (copyObj, currKey) {
                            copyObj[currKey] = _this2._getCopyByKey(currKey, params);
                            return copyObj;
                        }, {});
                    } else {
                        return this._getCopyByKey(key, params);
                    }
                }
            }, {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(BaseComponent, _extends({}, this.props, { copy: this.getCopy }));
                }
            }]);

            return Copied;
        }(_react.Component);

        Copied.displayName = wrappedDisplayName;
        Copied.contextTypes = {
            copier: _propTypes2.default.shape({
                copy: _propTypes2.default.object
            })
        };

        return Copied;
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/dibs-copy-provider/dist/copier.js
// module id = 1621
// module chunks = 4 5